import React from "react";
import { Button } from "antd";
import {
  WeaDialog,
  WeaTab,
  WeaFormItem,
  WeaSearchGroup,
  WeaPopoverHrm,
  WeaTable as WeaTableSelf,
  WeaLocaleProvider
} from "ecCom";
import WeaSwitch from "../../wea-switch";
import WeaTableNew from "../../wea-table-new";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import isEmpty from "lodash/isEmpty";
import forEach from "lodash/forEach";
import middleware from "../../../middleware";
const WeaTable = WeaTableNew.WeaTable;
const getLabel = WeaLocaleProvider.getLabel;

@observer
class LogComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && nextProps.visible != this.props.visible) {
      this.init(nextProps);
    }
  }

  componentDidMount() {
    if (this.props.visible) {
      this.init(this.props);
    }
  }

  init(nextProps) {
    const {
      logStore,
      logType,
      logSmallType,
      targetId,
      params = {}
    } = nextProps;
    logStore.update({
      logType,
      logSmallType,
      targetId,
      advanceShow: false,
      detailVisible: false
    });
    logStore.initForm();
    logStore.getDatas(params);
  }

  formatContent(record) {
    let temp = "";
    let newValues = {};
    let oldValues = {};
    if (record.newValues) {
      try {
        newValues = JSON.parse(record.newValues);
      } catch (error) {
        newValues = record.newValues;
      }
    }
    if (record.oldValues) {
      try {
        oldValues = JSON.parse(record.oldValues);
      } catch (error) {
        oldValues = record.oldValues;
      }
    }
    if (!isEmpty(newValues) || !isEmpty(oldValues)) {
      let target = isEmpty(newValues) ? oldValues : newValues;
      temp += `<ol style='list-style: decimal; margin-left: 20px'>`;
      forEach(target, (value, key) => {
        temp += `<li style='margin-bomtto: 4px'>[${key}]:&nbsp;`;
        if (oldValues[key] !== undefined && newValues[key] !== undefined) {
          temp =
            temp +
            getLabel("385867", '由&nbsp;"$s"修改为&nbsp;').replace(
              /\$s/,
              oldValues[key]
            ) +
            `"<span style='color: #FF0000'>${newValues[key]}</span>"</li>`;
        } else {
          temp += `${value}</li>`;
        }
      });
      temp += "</ol>";
    }
    return temp;
  }

  formatParams(record) {
    let text = "";
    if (!isEmpty(record.params)) {
      text = `<pre><code>${JSON.stringify(
        JSON.parse(record.params),
        null,
        2
      )}</code></pre>`;
    }
    return text;
  }

  render() {
    const {
      logStore,
      icon,
      iconBgcolor,
      title,
      className = "",
      style
    } = this.props;
    let { advanceShow, form, tableStore, conditions, targetId } = logStore;
    const buttons = [];
    if (logStore.showParams) {
      buttons.push(
        <Button
          key="clear"
          type="ghost"
          onClick={() => logStore.setShowParams(false)}
        >
          {getLabel("385865", "返 回")}
        </Button>
      );
    } else {
      buttons.push(
        <Button
          key="submit"
          type="primary"
          onClick={() => logStore.setShowParams(true)}
        >
          {getLabel("385866", "查看原始参数")}
        </Button>
      );
    }
    const temp = this.formatContent(toJS(logStore.detailRecord));
    const text = this.formatParams(toJS(logStore.detailRecord));

    return (
      <WeaDialog
        title={title || getLabel("31709", "日志查看")}
        style={{ height: 550, width: 1075 }}
        {...this.props}
        icon="icon-coms-currency"
        iconBgcolor="#217346"
      >
        <WeaPopoverHrm inDialog={true}>
          <WeaDialog
            hasScroll
            key={logStore.detailKey}
            onCancel={() => logStore.setDetailVisible(false)}
            title={`${logStore.detailTitle}`}
            icon={icon || "icon-coms-Flow-setting"}
            iconBgcolor={iconBgcolor || "#407008"}
            visible={logStore.detailVisible}
            style={{ width: 1000, height: 700 }}
            buttons={buttons}
            className="wea-log-view-detail"
          >
            {((!logStore.showParams && temp !== "") ||
              (logStore.showParams && text !== "")) && (
              <React.Fragment>
                <div
                  style={{ padding: 20, overflowX: "scroll" }}
                  dangerouslySetInnerHTML={{
                    __html: !logStore.showParams ? temp : text
                  }}
                />
                <br />
                <br />
              </React.Fragment>
            )}
            {!isEmpty(toJS(logStore.viewdetailDatas)) &&
              toJS(logStore.viewdetailDatas).map((datas, index) => {
                return (
                  <div style={{ paddingTop: "15px" }}>
                    <div
                      style={{
                        padding: "0 0 8px 12px",
                        borderBottom: "1px solid #e2e2e2"
                      }}
                    >
                      {toJS(logStore.viewdetailTitles)[index] == "@#"
                        ? ""
                        : toJS(logStore.viewdetailTitles)[index] + ":"}
                    </div>
                    {toJS(logStore.viewdetailColums).length > 0 &&
                      !isEmpty(toJS(logStore.viewdetailColums[index])) && (
                        <WeaTableSelf
                          columns={toJS(logStore.viewdetailColums[index])}
                          dataSource={toJS(datas)}
                          pagination={false}
                          scroll={{ x: 993, y: 700 }}
                        />
                      )}
                  </div>
                );
              })}
          </WeaDialog>
          <WeaTab
            searchType={["advanced"]}
            showSearchAd={advanceShow}
            setShowSearchAd={bool => {
              logStore.update({
                advanceShow: bool
              });
            }}
            hideSearchAd={() => logStore.update({ advanceShow: false })}
            searchsAd={getSearchs(form, conditions, targetId)}
            advanceHeight={160}
            buttonsAd={this.getTabButtonsAd()}
          />
          <div className="logview-table">
            <WeaTable
              comsWeaTableStore={tableStore}
              getColumns={this.getColumns}
              needScroll={true}
              outerHeight={480}
            />
          </div>
        </WeaPopoverHrm>
      </WeaDialog>
    );
  }
  //定义tab中点击高级搜索时的最下面的操作按钮集合
  getTabButtonsAd() {
    const { logStore, params = {} } = this.props;
    return [
      <Button
        type="primary"
        onClick={() => {
          logStore.getDatas(params);
          this.cancelAdvance();
        }}
      >
        {getLabel("197", "搜索")}
      </Button>,
      <Button type="ghost" onClick={() => logStore.form.resetConditionValue()}>
        {getLabel("2022", "重置")}
      </Button>,
      <Button type="ghost" onClick={this.cancelAdvance}>
        {getLabel("31129", "取消")}
      </Button>
    ];
  }

  cancelAdvance = () => {
    const { logStore } = this.props;
    logStore.update({
      advanceShow: false
    });
  };

  getColumns = columns => {
    const { logStore } = this.props;
    columns = columns.map(col => {
      if (col.dataIndex == "userid") {
        let newCol = { ...col };
        newCol.render = (value, record, index) => {
          return (
            <a
              href={`javaScript:openhrm(${record.userid});`}
              onClick={e => window.pointerXY(e)}
              title={record.useridspan}
            >
              {record.useridspan}
            </a>
          );
        };
        return newCol;
      } else if (col.dataIndex == "newValues") {
        let newCol = { ...col };
        newCol.render = (value, record, index) => {
          return (
            <a
              className="common"
              href="javascript:void(0);"
              onClick={() => {
                if (record.newValues) {
                  let title = `${record.operateTypespan} -
                  ${record.logsmalltypelabelnamespan || ""}
                  : ${record.targetNamespan}`;
                  logStore.setDetailTitle(title);
                  logStore.updateDetailkey(`${new Date().getTime()}`);
                  // logStore.setDetailVisible(true);
                  logStore.setShowParams(false);
                  logStore.setDetailRecord(record);
                  logStore.getDetailTable();
                }
              }}
            >
              {record.newValues || record.oldValues
                ? getLabel("33564", "查看")
                : ""}
            </a>
          );
        };
        return newCol;
      }
      return col;
    });
    return columns;
  };
}

export const getSearchs = (form, conditioninfo, targetId) => {
  const { isFormInit } = form;
  let group = [];
  if (isFormInit) {
    let formParams = form.getFormParams(); // 获取表单的值
    conditioninfo = toJS(conditioninfo);
    isFormInit &&
      conditioninfo.map(c => {
        let items = [];
        c.items.map(fields => {
          items.push({
            com: (
              <WeaFormItem
                label={`${fields.label}`}
                labelCol={{ span: `${fields.labelcol}` }}
                wrapperCol={{ span: `${fields.fieldcol}` }}
              >
                {/*根据 WeaSwitch 获取对应的组件*/}
                <WeaSwitch
                  fieldConfig={fields}
                  form={form}
                  formParams={formParams}
                />
              </WeaFormItem>
            ),
            colSpan: 1,
            hide: form.isHide(fields, keys => {
              if (keys.indexOf("targetId") >= 0 && targetId && targetId !== "")
                return true;
              return false;
            })
          });
        });
        group.push(
          <WeaSearchGroup
            needTigger={false}
            showGroup={c.defaultshow}
            items={items}
          />
        );
      });
  }
  return group;
};

const Com = middleware(LogComponent, "WeaLogView");
export default Com;



// WEBPACK FOOTER //
// ./comMobx/wea-log-view/components/LogComponent.js